/*
 * @Date         : 2021-03-17 16:13:53
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-06-23 23:52:29
 * @FilePath: /daodao-biz-front/src/request/further.ts
 */
import service from './base'
import axios from 'axios'
import { Common } from '@/interface/common.interface'
import { Further } from '@/interface/further.interface'

const basePath = '/api/v1'
const basePathV2 = '/api/v2'

export async function serveStatusStat(params: { clientId: Common.ClientId }): Promise<{
  statusStat: Array<Further.ServerTabItem>
}> {
  return await service({ url: `${basePath}/serveStatusStat`, method: 'POST', params })
}

// 获取升学规划用户档案信息
export async function getEnrollmentClientInfo(params: { clientId: Common.ClientId }): Promise<{
  client: Further.ClientInfo
  enrollmentClientInfo: Further.EnrollmentClientInfo
  stuOriginalScore: Further.StuOriginalScore
  scoreDetail: Further.ScoreDetail
}> {
  return await service({ url: `${basePath}/getEnrollmentClientInfo`, method: 'POST', params })
}

// 获取升学规划意向
export async function getEnrollmentClientIntention(params: {
  clientId: Common.ClientId
}): Promise<{ info: Further.UserEnrollmentClientIntentionInfo }> {
  return await service({ url: `${basePath}/getEnrollmentClientIntention`, method: 'POST', params })
}

// 获取高考填报的热门城市列表
export async function getHotCityList(): Promise<{
  items: Further.CityListItem[]
}> {
  return await service({ url: `${basePathV2}/hotCity`, method: 'POST', params: {} })
}

// 城市搜索
export async function citySearch(params: { locationName: string }): Promise<{
  items: Further.CityListItem[]
}> {
  return await service({ url: `${basePathV2}/citySearch`, method: 'POST', params })
}

// 获取所有专业
// /api/v1/majorInfoAll
export async function majorInfoAll(params: { diplomaId: number }): Promise<{
  subjects: Further.SubjectItem[]
  subject_count: number
  category_count: number
  major_count: number
}> {
  return await service({ url: `${basePath}/majorInfoAll`, method: 'POST', params })
}

// 根据省份获取高考推荐结构
export async function getRecommendConfV2(params: Further.GetRecommendConfReq): Promise<Further.RecommendConf> {
  return await service({ url: `${basePath}/getRecommendConfV2`, method: 'POST', params })
}

// 获取志愿表结构
export async function getZybConf(params: Further.ZybReq): Promise<Further.ZybConf> {
  return await service({ url: `${basePath}/getZybConf`, method: 'POST', params })
}

// 获取批次
export async function getBatchList(params: { clientId: Common.ClientId }): Promise<{ list: Further.BatchListItem[] }> {
  return await service({ url: `${basePath}/getBatchList`, method: 'POST', params })
}

// 院校搜索
export async function schSearch(params: { page_size: number; page: number; sch_name: string }) {
  return await service({ url: `${basePath}/schSearch`, method: 'POST', params })
}

// 专业搜索
export async function majorSearch(params: { page_size: number; page: number; keyword: string; diploma_id?: number }) {
  return await service({ url: `${basePath}/majorSearch`, method: 'POST', params })
}

// 冲稳保难统计 ratioTypeStatV2
export async function ratioTypeStatV2(params: Further.PriorFilterBase): Promise<{
  total: number
  ratio_type_list: Further.RatioTypeListItem[]
}> {
  return await service({ url: `${basePathV2}/ratioTypeStat`, method: 'POST', params })
}

// 院校专业综合推荐数据
export async function getPrior(params: Further.PriorReq): Promise<Further.PriorRecRsp> {
  return await service({ url: `${basePathV2}/prior`, method: 'POST', params })
}

// 院校专业综合推荐数据(专业类展开数据)
export async function getMcPrior(params: Further.PriorReq): Promise<Further.McPriorRecRsp> {
  return await service({ url: `${basePathV2}/mc_prior`, method: 'POST', params })
}

// 专业展开V2
export async function getEuExpandV2(params: Further.EuExpandV2Req): Promise<Further.EuExpandV2RecRsp> {
  return await service({ url: `${basePathV2}/enrollmentMajorExpand`, method: 'POST', params })
}

// 存储草稿箱志愿表
export async function saveDrafts(params: Further.ZyDraftData): Promise<Further.ZyDraftData> {
  return await service({ url: `${basePath}/saveDrafts`, method: 'POST', params })
}

// 获取草稿箱志愿表
export async function getDrafts(params: Further.ZyDraftInfo): Promise<Further.ZyDraftData> {
  return await service({ url: `${basePath}/getDrafts`, method: 'POST', params })
}

// 保存志愿方案 ：/api/v1/saveZyScheme
export async function saveZyScheme(params: Further.SaveZySchemeReq) {
  return await service({ url: `${basePath}/saveZyScheme`, method: 'POST', params })
}

// 保存志愿方案新：SaveZySchemeV2Req
export async function saveZySchemeV2(params: Further.SaveZySchemeV2Req) {
  return await service({ url: `${basePath}/saveZySchemeV2`, method: 'POST', params })
}

// 复制志愿表
export async function copyZy(params: { sourceZybId: number; clientId: Common.ClientId; type: number; data: any }) {
  return await service({ url: `${basePath}/copyZy`, method: 'POST', params })
}

// 获取志愿方案列表：/api/v1/getZybSchemeList
export async function getZybSchemeList(params: { clientId: Common.ClientId }) {
  return await service({ url: `${basePath}/getZybSchemeList`, method: 'POST', params })
}

// 获取志愿方案新：SaveZySchemeV2Req
export async function getZySchemeV2(params: {
  clientId: Common.ClientId
  zybId: string
}): Promise<Further.ZybSchemeData> {
  return await service({ url: `${basePath}/getZySchemeV2`, method: 'POST', params })
}

// 获取下载表格路径 getZySchemeExcel
export async function getZySchemeExcel(params: {
  clientId: Common.ClientId
  zybId: number
}): Promise<{ downloadUrl: string }> {
  return await service({ url: `${basePath}/getZySchemeExcel`, method: 'POST', params })
}

// 获取下载表格路径 getZySchemeExcel
export async function getZySchemeExcelV2(params: {
  clientId: Common.ClientId
  zybId: number
}): Promise<{ downloadUrl: string }> {
  return await service({
    url: `${basePathV2}/getZySchemeExcel`,
    method: 'POST',
    params: {
      ...params,
      zybId: params.zybId + '',
    },
  })
}

// 邀约建档 生成连接
export async function addInviteRequest(params) {
  return await service({ url: `${basePath}/invite/addClient`, method: 'POST', params })
}

// 添加升学规划用户档案
export async function upsertEnrollmentClientInfo(params: {
  serveScene?: number
  serveType?: number
  client: Further.ClientInfo
  enrollmentClientInfo: Further.EnrollmentClientInfo
  stuOriginalScore: Further.StuOriginalScore
}) {
  return await service({ url: `${basePath}/modifyEnrollmentClient`, method: 'POST', params })
}

// 添加升学规划用户档案
export async function setAddEnrollmentClient(params: {
  serveScene?: number
  serveType?: number
  client: Further.ClientInfo
  enrollmentClientInfo: Further.EnrollmentClientInfo
  stuOriginalScore: Further.StuOriginalScore
}) {
  return await service({ url: `${basePath}/addEnrollmentClient`, method: 'POST', params })
}

/**
 * 指派或更换老师
 * @param params
 */
export async function transformClientRelate(params?: {
  clientList: { clientId: Common.ClientId }[]
  counselor: string
  serveModule: number
  serveScene?: number
}) {
  return await service({ url: `${basePath}/transformClientRelate`, method: 'POST', params })
}

/**
 * 升学获客流转至1对1服务
 * @param params
 */
export async function reverseClientServeType(params?: Further.ReverseClientServeTypeReqParam) {
  return await service({ url: `${basePath}/reverseClientServeType`, method: 'POST', params })
}

/**
 * 修改升学规划获客信息
 */
export async function updateEnrollmentClient(params?: Further.UpdateEnrollmentClientReqParam) {
  return await service({ url: `${basePath}/updateEnrollmentClient`, method: 'POST', params })
}

/* ------------------发行志愿卡------------------ */
/**
 * 获取激活卡列表
 */
export async function cardBatchInfoList(params: any) {
  return await service({ url: `${basePath}/cardBatchInfo`, method: 'POST', params })
}

/**
 * 发行卡片
 */
export async function createCard(params: Further.CardBatchParams) {
  return await service({ url: `${basePath}/createCard`, method: 'POST', params })
}

/**
 * 获取机构激活卡数据
 */
export async function getCardModule(params = { cardChan: 0 }) {
  return await service({ url: `${basePath}/cardModule`, method: 'POST', params })
}

/**
 * 获取下载激活卡链接
 */
export async function oemCardExcel(params: { cardBatchId: number; cardChan: number }) {
  return await service({ url: `${basePath}/oemCardExcel`, method: 'POST', params })
}

/**
 * 获取招生计划异常数据
 */
export async function getZS_error() {
  return await axios.get('https://storage-oss.daodao.pro/daodao/enroll-config/enrollment-plan-anomalies-dialog.json')
}

/**
 * 获取消息盒子配置
 */
export async function msgBoxConfig() {
  return await axios.get('https://storage-oss.daodao.pro/daodao/enroll-config/msg-box-config1.json')
}

// 获取评测列表
export async function etopicsV2(params?: any) {
  return await service({ url: `${basePathV2}/etopics`, method: 'POST', params })
}

// 获取评测列表
export async function createEvaluation(params?: any) {
  return await service({ url: `${basePathV2}/createEvaluation`, method: 'POST', params })
}

// 招录数据书本/api/v2/getEnrollAdmissionBook
export async function getEnrollAdmissionBook(params?: {
  provinceId: string
  academicYear: number
  enrollAdmissionType: number
  euId: string
  emId?: string
}) {
  return await service({ url: `${basePathV2}/getEnrollAdmissionBook`, method: 'POST', params })
}
